var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-date-picker-years"},_vm._l((_setup.years),function(year){return _c('div',{key:year,staticClass:"bcx-pointer c-selectable-item",class:{ 'c-selected': year === _setup.selectedYear },on:{"click":function($event){return _setup.onSelectYear(year)}}},[_vm._v(" "+_vm._s(year)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }